import i18n from "../../locales/index"
import restful from "../vuex"


import {
  getBanners
} from "@/api/shop"

const state = {
  ...restful.states("banner"),
}

const getters = {
  ...restful.getters("banner"),
}

const actions = {
  ...restful.actions("banners"),
   getBannersList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getBanners(data)
          .then((data) => {
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
}

const mutations = {
  ...restful.mutations("banner"),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
